import React from 'react';
import { Dialog } from 'primereact/dialog';
import type { ChartOptions } from 'chart.js';
import { ChartModal } from './ChartModal';

export interface MarketTrendsModalProps {
  visible: boolean;
  onHide: () => void;
  selectedCompany: string | null;
  tempDateRange: { startDate: Date | null; endDate: Date | null };
  calendarViewDates: { startViewDate: Date | null; endViewDate: Date | null };
  getDefaultViewDate: (isStart?: boolean) => Date;
  handleTempDateRangeChange: (start: Date | null, end: Date | null) => void;
  setCalendarViewDates: (fn: ((prev: any) => any) | any) => void;
  handleApplyDateFilter: () => void;
  isLoadingMarketTrends: boolean;
  filteredMarketSalesTrendData: any[];
  marketSalesTrendData: any[];
  marketTrendsData: any;
  marketTrendsOptions: ChartOptions;
  classes: any;
}

export function MarketTrendsModal({
  visible,
  onHide,
  selectedCompany,
  tempDateRange,
  calendarViewDates,
  getDefaultViewDate,
  handleTempDateRangeChange,
  setCalendarViewDates,
  handleApplyDateFilter,
  isLoadingMarketTrends,
  filteredMarketSalesTrendData,
  marketSalesTrendData,
  marketTrendsData,
  marketTrendsOptions,
  classes,
}: MarketTrendsModalProps) {
  return (
    <Dialog
      header="Market Sales Trends by Agency"
      visible={visible}
      style={{ width: '90vw', height: '90vh' }}
      onHide={onHide}
      maximizable
      blockScroll
    >
      <ChartModal
        selectedCompany={selectedCompany}
        tempDateRange={tempDateRange}
        calendarViewDates={calendarViewDates}
        getDefaultViewDate={getDefaultViewDate}
        handleTempDateRangeChange={handleTempDateRangeChange}
        setCalendarViewDates={setCalendarViewDates}
        handleApplyDateFilter={handleApplyDateFilter}
        isLoadingMarketTrends={isLoadingMarketTrends}
        filteredMarketSalesTrendData={filteredMarketSalesTrendData}
        marketSalesTrendData={marketSalesTrendData}
        marketTrendsData={marketTrendsData}
        marketTrendsOptions={marketTrendsOptions}
        classes={classes}
      />
    </Dialog>
  );
}
